import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PositionError } from '@ionic-native/geolocation/ngx';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { encodeAddressForGoogle } from '../../utils/utils';
import { BaseService } from '../core/base.service';
import { MMobileHelperService } from '../core/mmobile-helper.service';

@Injectable({
  providedIn: 'root'
})
export class GeocoderService {
  constructor(
    private http: HttpClient,
    private base: BaseService,
    private mmobileHelper: MMobileHelperService,
  ) {}

  getCurrentPosition() {
    const locationOptions: any = {
      timeout: 10000,
      enableHighAccuracy: true
    };
    if (navigator.userAgent.indexOf('MSIE') !== -1) {
      locationOptions.enableHighAccuracy = false;
      locationOptions.maximumAge = 50000;
    }

    return new Observable<{ coords: { latitude: number, longitude: number }}>((observer) => {
      navigator.geolocation.getCurrentPosition(
        position => observer.next(position),
        (err: PositionError) => observer.error(err),
        locationOptions
      );
    }).pipe(take(1));
  }

  geocodeAddress(address: string) {
    let url = this.mmobileHelper.getServiceUrl('geocode');
    url += `?region=es&language=es&address=${encodeAddressForGoogle(
      address
    )},Spain`;
    return this.http.get<any>(url, this.base.getPublicHeaders());
  }

  geocodeLatLng(lat: number, lng: number) {
    let url = this.mmobileHelper.getServiceUrl('geocode');
    url += `?region=es&language=es&latlng=${lat},${lng}`;
    return this.http.get<any>(url, this.base.getPublicHeaders());
  }

}
